/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { getPageInquiryInfoUrl, isPageInquiryInfoExternalUrl } from './utils/getInquiryInfoUrl';

export {
    getPageInquiryInfoUrl,
    isPageInquiryInfoExternalUrl,
};
